export const TeeIcon: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 256 256"
    {...props}
  >
    <path
      fill="rgb(254, 209, 0)"
      d="M128,3.18h0c68.88,0,124.72,55.84,124.72,124.72h0c0,68.88-55.84,124.72-124.72,124.72h0C59.12,252.63,3.28,196.79,3.28,127.9h0C3.28,59.02,59.12,3.18,128,3.18Z"
    />
    <path
      fill="currentColor"
      d="M128,254.63C58.12,254.63,1.28,197.78,1.28,127.9S58.12,1.18,128,1.18s126.72,56.85,126.72,126.72-56.85,126.72-126.72,126.72ZM128,5.18C60.33,5.18,5.28,60.23,5.28,127.9s55.05,122.72,122.72,122.72,122.72-55.05,122.72-122.72S195.67,5.18,128,5.18Z"
    />
    <path
      fill="currentColor"
      d="M177.83,131.33l-44.03,43.97V58.29h-11.6v117.01l-44.03-43.97-8.18,8.18,58.01,58.01,58.01-58.01-8.18-8.18Z"
    />
  </svg>
);
